/**
 * modifySelectWindow — validating wrapper for the `modify-select-window`
 * SR-Edit op. The applicator replaces the target SELECT item's ENTIRE
 * `OVER …` range verbatim with `newOverText`, so the payload must itself
 * start with the `OVER` keyword — a bare `(PARTITION BY x)` (missing the
 * keyword) would corrupt the emitted SQL. Out-of-range `selectItemIndex` and
 * windowless items are resolver-level no-ops (see
 * `applyStructuralEdit.modify.ts` `planModifySelectWindow`), not errors here.
 */
import type { CommitEditCtx } from '../commitEdit';
import { commitEdit } from '../commitEdit';

export async function modifySelectWindow(
  selectItemIndex: number,
  newOverText: string,
  ctx: CommitEditCtx,
): Promise<void> {
  if (!Number.isInteger(selectItemIndex) || selectItemIndex < 0) {
    throw new Error(
      `modifySelectWindow: selectItemIndex must be a non-negative integer (got ${selectItemIndex})`,
    );
  }
  const text = newOverText.trim();
  if (text.length === 0) throw new Error('modifySelectWindow: newOverText must not be empty');
  if (!/^over\b/i.test(text)) {
    throw new Error('modifySelectWindow: newOverText must start with OVER — the whole clause is replaced verbatim');
  }
  await commitEdit({ op: 'modify-select-window', selectItemIndex, newOverText: text }, ctx);
}
